export default __webpack_public_path__ + "c47970fe9087c3b4d9ec774a192936f1.png";